// extracted by mini-css-extract-plugin
module.exports = {"text-action":"_typo_text-action__36qVP","text-lighter":"_typo_text-lighter__3eqIO","h4-text":"_typo_h4-text__3DYPx"};